/*
 * MAPAGI'S — correção do botão de checkout do Yampi.
 *
 * PROBLEMA
 * O script do Yampi (snippets/YampiSnippet.liquid) clona o botão de finalizar
 * compra e liga o clone à função fakeClick(). Essa função consulta
 * api.dooki.com.br enviando apenas { shop, cart_payload } — ou seja, só o
 * domínio mapagiscoffee.shop. A API responde "Merchant not found" e devolve
 * checkout_direct_url vazio; o script faz window.location.href = '' e a página
 * apenas recarrega.
 *
 * A mesma consulta funciona quando inclui shopify_internal_domain (o domínio
 * .myshopify.com) — que é o que o próprio Yampi envia ao carregar a página do
 * carrinho, e por isso o botão chega a ser clonado e window.yampiCheckoutUrl
 * fica preenchido.
 *
 * SOLUÇÃO
 * Substituímos o botão do Yampi por uma cópia limpa (sem os listeners dele) e
 * ligamos nosso próprio clique, que refaz a consulta com shopify_internal_domain.
 * Se a consulta falhar, usamos a URL que o Yampi já guardou em
 * window.yampiCheckoutUrl.
 *
 * Quando o Yampi passar a reconhecer o domínio próprio da loja, este arquivo
 * pode ser removido sem prejuízo.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var MARK = 'mpYampiFixed';

  function loader(show) {
    var el = document.querySelector('.yampi-loader');
    if (el) el.style.display = show ? 'block' : 'none';
  }

  function withUtms(url) {
    try {
      if (typeof window.ymp_getUrlWithUtms === 'function') return window.ymp_getUrlWithUtms(url);
    } catch (e) {}
    return url;
  }

  function go(url) {
    if (!url) return false;
    window.location.href = withUtms(url);
    return true;
  }

  function handle(e) {
    e.preventDefault();
    loader(true);

    var fallback = function () {
      if (go(window.yampiCheckoutUrl)) return;
      loader(false);
      if (window.console) console.error('[MAPAGIS] Yampi nao devolveu a URL do checkout.');
    };

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = { shop: window.location.host, cart_payload: cart };
        body.shopify_internal_domain = window.shopifyInternalUrl;
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (!resp || !resp.checkout_direct_url) return fallback();
        go(resp.checkout_direct_url);
      })
      .catch(fallback);
  }

  function patch() {
    var buttons = document.querySelectorAll('.ymp_elem_mainBtn');
    for (var i = 0; i < buttons.length; i++) {
      var old = buttons[i];
      if (old.dataset[MARK]) continue;
      // Clonar remove os listeners que o Yampi ligou ao botão.
      var fresh = old.cloneNode(true);
      fresh.dataset[MARK] = '1';
      fresh.type = 'button';
      fresh.addEventListener('click', handle);
      if (old.parentNode) old.parentNode.replaceChild(fresh, old);
    }
  }

  function start() {
    if (!window.fetch) return; // navegador antigo: deixa o fluxo original do Yampi
    patch();
    if (window.MutationObserver) {
      new MutationObserver(patch).observe(document.documentElement, { childList: true, subtree: true });
    } else {
      setInterval(patch, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
